export const NO_PROMPT = 'noPrompt';
export const TRUTHY_VALUE = 'true';
